import {ImageOpContextImgProc} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-context-imgproc"
import {assertNoBatching} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/utils/image-op-utils"
import {createImageOpImgProc} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/imgproc/image-op-imgproc-utils"
import {definition} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/resize/definition"
import {Evaluator, registerNode} from "@cm/graph-v2-final"
import {ImageOpResizeHal} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/resize/hal"
import {ImageOpParametersOfType} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/specializing-image-op-node"
import {ImageOpInputsOrNodes} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {BasicSpecializingImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/basic-specializing-image-op-node"

@registerNode
export class ImageOpNodeResize extends BasicSpecializingImageOpNode<typeof definition, ImageOpResizeHal> {
    static nodeClass = "ImageOpNodeResize"
    static definition = definition

    constructor(parameters: ImageOpInputsOrNodes<typeof definition>) {
        super(ImageOpResizeHal, parameters)
    }

    override toImgProc = async (evaluator: Evaluator<ImageOpContextImgProc>, parameters: ImageOpParametersOfType<typeof definition, "imgproc">) => {
        const {sourceImage, interpolationMode, resultSize} = await evaluator.getAll(parameters)
        assertNoBatching(sourceImage.descriptor)
        return createImageOpImgProc(sourceImage.descriptor, {
            type: "resize",
            input: sourceImage.node,
            width: resultSize.width,
            height: resultSize.height,
            interpolationMode: interpolationMode,
        })
    }
}
